<!--
 * @Description: 
 * @Date: 2019-01-15 19:30:59
-->
<template>
  <ul class="hasPadding">
    <!-- 小程序中不显示 -->
    <template v-for="(item, index) in list">
      <li
        class="vux-1px-b"
        :key="index"
        @click="jump(item)"
        v-if="!isHttps || (isHttps && !item.externalLink)"
      >
        <img :src="item.bgUrl" alt="" />
        <div class="bd">
          <span class="bs1">{{ item.title }}</span>
          <span class="bs2">订阅：{{ item.subNum }}人</span>
        </div>
      </li>
    </template>
  </ul>
</template>
<script>
import { yshJumpSaas } from '@/api/ajax';

export default {
  name: '',
  props: {
    list: {
      type: Array,
      default: function() {
        return [{}];
      }
    }
  },
  data() {
    return {
      isHttps: false
    };
  },
  methods: {
    async jump(item) {
      if (item.yshToSaasUrl) {
        const phone = this.$store.state.wxUserInfo.phone;
        await yshJumpSaas({
          phone
        });
        window.location.href = `${item.yshToSaasUrl}?from=ysh&phone=${phone}`;
        return;
      }
      if (item.externalLink) {
        this.$sa.setSaSession_href(this.$route, item.externalLink);
      } else {
        this.$router.push({ name: 'universally', params: { id: item.id } });
      }
    }
  },
  computed: {},
  components: {},
  created() {
    this.isHttps = this.$config.protocol === 'https';
  }
};
</script>
<style lang="less" scoped>
ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  li {
    width: 100%;
    /*margin-bottom: .6rem;*/
    /*margin-top: .2rem;*/
    padding-bottom: 0.56rem;
    padding-top: 0.2rem;
    * {
      font-size: 0.3733rem;
    }
    img {
      width: 9.2rem;
      height: 4.4rem;
      border-radius: 0.1rem;
    }
    .bd {
      display: flex;
      justify-content: space-between;
      margin-top: 0.05rem;
      padding-left: 0.266rem;
      .bs1 {
        width: 6.5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .bs2 {
        color: #999;
      }
    }
  }
}
</style>
